<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9pb11w/tc-custom/9781523003280.jpg?1716906103135" alt="This image is the cover for the book Art of Conscious Conversations"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Art of Conscious Conversations
      </h1>
      <p class="bookDescription body article font2">
        <b>Recognize the negative mental habits that derail conversations and destroy projects—and forge authentic, enduring, and productive connections.</b><br/><br/> We live in conversations like fish live in water—we’re in them all the time, so we don’t think about them much. As a result, we can find ourselves stuck in cyclical patterns of unproductive behaviors. We listen half-heartedly, react emotionally, and respond habitually, like we’re on autopilot.<br/><br/> This is a practical guide for thoughtfully reflecting on conversations and avoiding the common pitfalls that cause our relationships and work to go sideways. Chuck Wisner identifies four universal types of conversations and offers specific advice to maximize the effectiveness of each:<br/><br/><b>Storytelling</b>—Investigate the stories we tell ourselves about ourselves and others<br/><b>Collaborative</b>—Explore the way our stories and other people’s stories interact<br/><b>Creative</b>—See new possibilities and discover unforeseen solutions<br/><b>Commitment</b>—Make promises we know we can keep<br/><br/> These conversations unfold sequentially: Our awareness of our and others’ stories transforms our ability to listen and collaborate, which opens our thoughts to creative possibilities, guiding us toward mindful agreements.<br/><br/> Our conversations—at home, at work, or in public—can be sources of pleasure and stepping-stones toward success, or they can cause pain and lead to failure. Wisner shows how we can form a connection from the very first conversation and keep our discourse positive and productive throughout any endeavor.<br/>  <br/> “A compelling read with a big impact.” —Susan McPherson, author of <i>The Lost Art of Connecting</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chuck Wisner
      </h2>
      
      <p class="authorDescription body article">Chuck Wiser is president of Wisner Consulting. His client list includes companies such as Google, Rivian, Apple, Tesla, Harvard Business School, Ford, and Chrysler. Wisner was a senior affiliated mediator with the Harvard Mediation Program and was among the first to be certified through the Mastering the Art of Professional Coaching program at the Newfield Institute. He was also a specialist in organizational learning and leadership as an affiliate with MIT's Center for Organizational Learning.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fcc1aff4